import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddOrEdit from './components/index.vue';

var EditVasOrderPage = function (_super) {
  __extends(EditVasOrderPage, _super);

  function EditVasOrderPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EditVasOrderPage = __decorate([Component({
    components: {
      AddOrEdit: AddOrEdit
    }
  })], EditVasOrderPage);
  return EditVasOrderPage;
}(Vue);

export default EditVasOrderPage;